import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import PayrollSettings from '../payroll-settings/payroll-settings';
import { SectionContainer } from './styles';
import type { PayrollForm } from './types';

interface PayrollSettingsElementProps {
  form: PayrollForm;
}

const PayrollSettingsElement = ({ form }: PayrollSettingsElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <PayrollSettings />
    </FormProvider>
  </SectionContainer>
);

export default memo(PayrollSettingsElement);
